module.exports = __webpack_public_path__ + "img/who_tests_what.dcf772da.png";